var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"item",on:{"click":_vm.goToStorePage}},[_c('div',{staticClass:"child"},[_vm._v("去查看")]),_vm._v(" "),_c('div',{staticClass:"child"},[_vm._v("更多商品")])])])}
var staticRenderFns = []

export { render, staticRenderFns }